import React, { useLayoutEffect, useRef, useState } from 'react';

import MoreLess from '@/common/more-less/more-less';

import './index.less';

interface IPropType {
  pointsList: string[];
  i18n: DetailTypes.i18n;
}
export default function SellingPoint(props: IPropType) {
  const { pointsList = [], i18n } = props;
  if (pointsList.length === 0) return null;

  const ulRef = useRef<HTMLUListElement>(null);
  const [shown, setShown] = useState(0);

  const [visiable, setVisiable] = useState(false);
  useLayoutEffect(() => {
    const ulEl = ulRef.current;
    if (ulEl !== null) {
      const showMoreMinHeight = 70 + 20 + 22;
      setShown(ulEl.getBoundingClientRect().height > showMoreMinHeight ? 1 : -1);
      setVisiable(true);
    }
  }, []);

  return (
    <div className="sellingpoint" style={{ visibility: visiable ? 'visible' : 'hidden' }}>
      <div id="sellingpoint" className="header">
        {i18n['detail_ai_summary_about_this_product']}
      </div>
      <ul ref={ulRef} className={shown === 1 ? 'show-more' : ''}>
        {pointsList.map(p => (
          <li>{p}</li>
        ))}
        {shown > -1 && (
          <MoreLess
            elementId="#sellingpoint"
            logMoreName="/sc.details.sellingpointViewMore"
            logLessName="/sc.details.sellingpointViewLess"
            i18n={i18n}
            shown={shown}
            updateShown={(v: number) => setShown(v)}
          />
        )}
      </ul>
    </div>
  );
}
